// @flow
import type {PersonalPreferencesDTO, Preferences, NotificationMethod} from '../../lib/definitions/swagger'
import type {Dispatch, Action, GetState, ThunkPromiseAction} from '../../lib/definitions/redux'

import WS from '../../lib/websocket'
import {formValueSelector, SubmissionError} from 'redux-form'
import {version as communicationSettingsVersion} from '../../lib/data/communicationSettings'
import objectPath from 'object-path'
import Immutable from 'seamless-immutable'

import * as preferencesAPI from '../../lib/api/preferences'
import * as loadingActions from './loading'

export const PREFERENCES_UPDATE_PERSONAL_DETAILS = 'PREFERENCES_UPDATE_PERSONAL_DETAILS'
export const PREFERENCES_GET_PERSONAL_DETAILS = 'PREFERENCES_GET_PERSONAL_DETAILS'
export const PREFERENCES_SET_NOTIFICATION = 'PREFERENCES_SET_NOTIFICATION'
export const PREFERENCES_GET = 'PREFERENCES_GET'
export const PREFERENCES_SET = 'PREFERENCES_SET'
export const PREFERENCES_SET_COMMUNICATION_TYPE = 'PREFERENCES_SET_COMMUNICATION_TYPE'
export const COMMUNICATION_TYPE_NONE = 'COMMUNICATION_TYPE_NONE'
export const COMMUNICATION_SET_SEEN_QUICK_POPUP = 'COMMUNICATION_SET_SEEN_QUICK_POPUP'


export const FORM_NAME = 'PERSONAL_DETAILS_FORM'
const formSelector = formValueSelector(FORM_NAME)

export function getPersonalDetails() : ThunkPromiseAction<Action>{
	return (dispatch : Dispatch) => {
		return loadingActions.promise(
			dispatch,
			PREFERENCES_GET_PERSONAL_DETAILS,
			preferencesAPI.getUserInfo()
				.then((response) => dispatch(_setPersonalDetails(response)))
		)
	}
}


function _setPersonalDetails(data : PersonalPreferencesDTO) : Action{
	return {
		type: PREFERENCES_GET_PERSONAL_DETAILS,
		personalDetails: data
	}
}

export function updatePersonalDetails() : ThunkPromiseAction<Action>{
	return (dispatch : Dispatch, getState : GetState) => {
		const {preferredName, email, mobilePhone} = formSelector(getState(), 'preferredName', 'email', 'mobilePhone')

		return loadingActions.promise(
			dispatch,
			PREFERENCES_UPDATE_PERSONAL_DETAILS,
			preferencesAPI.updatePersonalPreferences(
				preferredName,
				email,
				mobilePhone
			)
				.then((id) => WS.waitFor(id))
		)
			.then(() => dispatch(setNotification('Personal details saved.')))
			.then(() => dispatch(_setPersonalDetails({preferredName, email, mobileNumber: mobilePhone})))
			.catch((e) => {
				throw new SubmissionError({
					"_error": e.message
				})
			})
	}
}

export function clearNotification() : Action{
	return setNotification(undefined)
}

export function setNotification(message : ?string) : Action{
	return {
		type: PREFERENCES_SET_NOTIFICATION,
		notification: message
	}
}

export function getPreferences(filter : Array<string> = []) : Preferences{
	return (dispatch : Dispatch) => {
		return loadingActions.promise(
			dispatch,
			PREFERENCES_GET,
			preferencesAPI.getPreferences(filter)
				.then((response) => dispatch(_setPreferences(undefined, response)) && response)
		)
	}
}

export function _setPreferences(key : ?$Keys<Preferences> = undefined, preferences: Object) : Action{
	return {
		type: PREFERENCES_SET,
		key,
		preferences
	}
}

/**
 * Sets the communication method for that communication type
 * @param type
 * @param method
 * @return {function(*=): (Promise.<T>|Promise.<T>)}
 */
export function setCommunicationType(type : $Keys<Preferences>, method: $Keys<NotificationMethod>) : ThunkPromiseAction<Action>{
	return (dispatch, getState) =>
		loadingActions.promise(
			dispatch,
			PREFERENCES_SET_COMMUNICATION_TYPE,
			preferencesAPI.setCommunicationPreference(type, method)
				.then((id) => WS.waitFor(id))
				.then(() => {
					let options = objectPath.get(getState(), ['Preferences', 'remoteCommunication', type], {
						"push": false,
						"sms": false,
						"webMessage": false,
						"email": false
					})

					options = Immutable.isImmutable(options) ? options.asMutable() : options

					for(let key of Object.keys(options)){
						options[key] = key === method
					}

					dispatch(_setPreferences(type, options))
				})
		)
}

export function setSeenQuickCommunicationSettings() : Action{
	return {
		type: COMMUNICATION_SET_SEEN_QUICK_POPUP,
		version: communicationSettingsVersion
	}
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/actions/preferences.js